import { Authority } from 'platform/app/authority.constant';

export const MASTER_TEMPLATES = {
    name: 'Master templates',
    path: '/admin-panel/master-templates',
    redirectTo: '/admin-panel/master-templates/teaser',
    requiresAuthority: Authority.ROLE_ADMIN_PANEL_VIEW_EDIT,
};
